import ListSaveButton from "../../Components/ListSaveButton";
import PageTabs from "../../Components/PageTabs";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import TableButton from "../../Props/TableButton";
import ItemMaster from "../../../API/APIServices/ItemMaster";
import AutoSuggestionBox from "../../Components/AutoSuggestionBox";
import MyContext from "../../MyContext";
import Account from "../../../API/APIServices/Account";
import LensItemCreation from "../../../API/APIServices/LensItemCreation";
import Loader from "../../Props/Loader";
import MainButton from "../../Props/MainButton";
import PartyWiseItemPriceService from "../../../API/APIServices/PartyWiseItemPriceService";
import Swal from "sweetalert2";
import RangeInput from "../../LensTransaction/RangeInput";
import PaginationControl from "../TableMaster/PaginationControl";

function ProductPriceAccCatWise() {
  /***********title***************/
  useState(() => {
    document.title = "Product Price Account Category Wise";
  }, []);

  const { debounce } = useContext(MyContext);
  const [loading, setLoading] = useState(document.readyState !== "complete");
  const [showFilterPopUp, setShowFilterPopUp] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState();
  const [pageSize, setpageSize] = useState(50);
  // Sample data

  const [filteredItems, setFilteredItems] = useState([]);
  const [axisData, setAxisData] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDropdownOpen1, setIsDropdownOpen1] = useState(false);

  useEffect(() => {
    const handleReadyStateChange = () => {
      if (document.readyState === "complete") {
        setLoading(false);
      }
    };

    if (document.readyState !== "complete") {
      document.addEventListener("readystatechange", handleReadyStateChange);
    }

    return () => {
      document.removeEventListener("readystatechange", handleReadyStateChange);
    };
  }, []);

  const handleKeyPress = (event, nextInputRef) => {
    if (event.key === "Enter") {
      event.preventDefault();
      nextInputRef.current.focus();
    }
  };

  // Handlers
  const handleprev = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const handlenext = () => {
    const totalPages = Math.ceil(totalRecords / pageSize);
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };
  const isFirstRender = useRef(true);

  const fetchLensData = async (pageNumber, pageSize) => {
    if (!inputValues.ItemId) {
      alert("Product selection is required");
      return;
    }
    if (!inputValues.Eye) {
      alert("Please Select Required values (Eye)");
      return;
    }
    try {
      setLoading(true);
      const requestData = {
        ...inputValues,
        pageNumber,
        pageSize,
      };

      const LensData = await LensItemCreation.getLensItemCreationById(
        requestData
      );

      if (LensData) {
        const updatedData = LensData.items.map((lens) => ({
          isSelected: false,
          itemd2_Id: lens.d2Id,
          itemName: lens.name ?? "",
          parentGroup: lens.parentGrpName ?? "-----",
          salePrice: lens.salePrice ?? 0,
          purchasePrice: lens.purchasePrice ?? 0,
          costPrice: lens.costPrice ?? 0,
          mrpPrice: lens.mrpPrice ?? 0,
          catAPrice: lens.cateRateA ?? 0,
          catBPrice: lens.cateRateB ?? 0,
          catCPrice: lens.cateRateC ?? 0,
          catDPrice: lens.cateRateD ?? 0,
          catEPrice: lens.cateRateE ?? 0,
          catFPrice: lens.cateRateF ?? 0,
          catGPrice: lens.cateRateG ?? 0,
          catHPrice: lens.cateRateH ?? 0,
          catIPrice: lens.cateRateI ?? 0,
          catJPrice: lens.cateRateJ ?? 0,
        }));
        setProductPriceCategoryWiseData(updatedData);
      }
    } catch (error) {
      console.error("Error fetching lens data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    fetchLensData(currentPage, pageSize);
  }, [currentPage]);

  const ShowButtonClick = async (axis) => {
    setLoading(true);
    if (inputValues.ItemId == "") {
      alert("Product selection is required");
      return;
    }
    if (inputValues.Eye == "") {
      alert("Please Select Requried values (Eye)");
      return;
    }

    try {
      // {
      //   "itemId": 120193,
      //   "spH_Min": 1,
      //   "spH_Max": 1,
      //   "spH_Step": 0.25,
      //   "cyL_Min": 1,
      //   "cyL_Max": 2,
      //   "cyL_Step": 0.25,
      //   "axis": "90",
      //   "add_Min": 1,
      //   "add_Max": 2,
      //   "add_Step": 0.25,
      //   "eye": "RL",
      //   "pageNumber": 0,
      //   "pageSize": 50
      // }

      const tempInputValues = {
        ParentGrp: inputValues.ParentGrp,
        ItemName: inputValues.ItemName,
        ItemId: inputValues.ItemId,
        SPH_Min: Number(inputValues.SPH_Min) || 0,
        SPH_Max: Number(inputValues.SPH_Max) || 0,
        SPH_Step: Number(inputValues.SPH_Step) || 0,
        CYL_Min: Number(inputValues.CYL_Min) || 0,
        CYL_Max: Number(inputValues.CYL_Max) || 0,
        CYL_Step: Number(inputValues.CYL_Step) || 0,
        Axis: Number(inputValues.Axis) || 0,
        Add_Min: Number(inputValues.Add_Min) || 0,
        Add_Max: Number(inputValues.Add_Max) || 0,
        Add_Step: Number(inputValues.Add_Step) || 0,
        Eye: inputValues.Eye,
      };

      const requestData = {
        ...tempInputValues,
        Axis: Number(selectedAxis) || 0,
        pageNumber: currentPage,
        pageSize,
      };

      ;
      const LensData = await LensItemCreation.getLensItemCreationById(
        requestData
      );
      if (LensData) {
        const updatedData = LensData.items.map((lens) => ({
          isSelected: false,
          itemd2_Id: lens.d2Id,
          itemName: lens.name ?? "",
          parentGroup: lens.parentGrpName ?? "-----",
          salePrice: lens.salePrice ?? 0,
          purchasePrice: lens.purchasePrice ?? 0,
          costPrice: lens.costPrice ?? 0,
          mrpPrice: lens.mrpPrice ?? 0,
          catAPrice: lens.cateRateA ?? 0,
          catBPrice: lens.cateRateB ?? 0,
          catCPrice: lens.cateRateC ?? 0,
          catDPrice: lens.cateRateD ?? 0,
          catEPrice: lens.cateRateE ?? 0,
          catFPrice: lens.cateRateF ?? 0,
          catGPrice: lens.cateRateG ?? 0,
          catHPrice: lens.cateRateH ?? 0,
          catIPrice: lens.cateRateI ?? 0,
          catJPrice: lens.cateRateJ ?? 0,
        }));
        setProductPriceCategoryWiseData(updatedData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDataSelection = async (Data, index, Name) => {
    ;
    setLoading(true);

    try {
      const LensItemRange = await LensItemCreation.getLensItemCreationByItemId(
        Data.id
      );

      if (LensItemRange) {
        const Axis = LensItemRange.axis.split(",");
        setInputValues({
          ParentGrp: Data.parentGrpName,
          ItemName: Data.name,
          ItemId: LensItemRange.itemId,
          SPH_Min: LensItemRange.spH_Min,
          SPH_Max: LensItemRange.spH_Max,
          SPH_Step: LensItemRange.spH_Step,
          CYL_Min: LensItemRange.cyL_Min,
          CYL_Max: LensItemRange.cyL_Max,
          CYL_Step: LensItemRange.cyL_Step,
          Axis: LensItemRange.axis.split(",")[0],
          Add_Min: LensItemRange.add_Min,
          Add_Max: LensItemRange.add_Max,
          Add_Step: LensItemRange.add_Step,
          Eye: LensItemRange.eye,
        });
        setShowFilterPopUp(true);

        let axisName = Axis.length === 0 ? "" : Axis[0];
        setSelectedAxis(axisName);
        setAxisData(Axis);
        const updatedLensItemRange = {
          ...LensItemRange,
          axis: LensItemRange.axis.split(",")[0],
        };

        const LensData = await LensItemCreation.getLensItemCreationById1(
          updatedLensItemRange
        );
        if (LensData.isSuccess) {
          ;
          setTotalRecords(LensData.totalRecords);
          const updatedData = LensData.result.items.map((lens) => ({
            isSelected: false,
            itemd2_Id: lens.d2Id,
            itemName: lens.name ?? "",
            parentGroup: lens.parentGrpName ?? "-----",
            salePrice: lens.salePrice ?? 0,
            purchasePrice: lens.purchasePrice ?? 0,
            costPrice: lens.costPrice ?? 0,
            mrpPrice: lens.mrpPrice ?? 0,
            catAPrice: lens.cateRateA ?? 0,
            catBPrice: lens.cateRateB ?? 0,
            catCPrice: lens.cateRateC ?? 0,
            catDPrice: lens.cateRateD ?? 0,
            catEPrice: lens.cateRateE ?? 0,
            catFPrice: lens.cateRateF ?? 0,
            catGPrice: lens.cateRateG ?? 0,
            catHPrice: lens.cateRateH ?? 0,
            catIPrice: lens.cateRateI ?? 0,
            catJPrice: lens.cateRateJ ?? 0,
          }));
          setProductPriceCategoryWiseData(updatedData);
        }
      } else {
        Swal.fire({
          icon: "info",
          title: "No Lens Data Available",
          text: "No lens items were found for the selected range.",
          timer: 2500,
          timerProgressBar: true,
          showConfirmButton: false,
          width: "250px",
          customClass: {
            title: "swal2-custom-title",    confirmButton: 'my-confirm-button',
    cancelButton: 'my-cancel-button' ,

            popup: "swal2-custom-popup",
            htmlContainer: "swal2-custom-text",
            icon: "swal2-custom-icon",
          },
        });
      }

      setIsDropdownOpen(false);
      setIsDropdownOpen1(false);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchdataSuggestions = async (name, value, GroupId, masterType) => {
    const filteredData = {
      MasterType: masterType,
      GroupWiseSuggestion: true,
      GroupId: GroupId,
      search_str: value,
      PageNumber: 1,
      PageSize: 500,
    };

    try {
      const SearchItem = await Account.GetAccountListForAutoSuggestion(
        filteredData
      );
      return SearchItem;
    } catch (error) {
      console.error("Error fetching account suggestions:", error);
      return null;
    }
  };

  const debouncedFetchDataSuggestions = useCallback(
    debounce(async (name, value, GroupId, masterType) => {
      const SearchItem = await fetchdataSuggestions(
        name,
        value,
        [],
        masterType
      );
      setIsDropdownOpen(true);
      setIsDropdownOpen1(true);
      if (SearchItem) {
        setFilteredItems(SearchItem);
      }
    }, 500),
    []
  );

  const handleInputChange = (event, masterType) => {
    const { name, value } = event.target;

    debouncedFetchDataSuggestions(name, value, [], masterType);
  };

  function showShowFilterPopUp() {
    setShowFilterPopUp(!showFilterPopUp);
  }

  // function hideShowFilterPopUp() {
  //   setShowFilterPopUp(false);
  // }

  const handleSelectAll = (e) => {
    let boolVal = e.target.checked;

    let tempProductPriceCategoryWiseData = productPriceCategoryWiseData.map(
      (item) => {
        return {
          ...item,
          isSelected: boolVal,
        };
      }
    );

    setIsAllSelected(boolVal);
    setProductPriceCategoryWiseData(tempProductPriceCategoryWiseData);
  };

  const [copyBtnRC, setCopyBtnRC] = useState({ R: -1, C: -1 });
  const [selectedRateField, setSelectedRateField] = useState("Rate A");
  const [selectedBaseField, setSelectedBaseField] = useState("salePrice");
  const [selectedOperator, setSelectedOperator] = useState("-");
  const [calculationValue, setCalculationValue] = useState(0);
  const [productPriceCategoryWiseData, setProductPriceCategoryWiseData] =
    useState([
      {
        isSelected: false,
        itemd2_Id: 0,
        itemName: "",
        parentGroup: "-----",
        purchasePrice: 0,
        costPrice: 0,
        mrpPrice: 0,
        salePrice: 0,
        catAPrice: 0,
        catBPrice: 0,
        catCPrice: 0,
        catDPrice: 0,
        catEPrice: 0,
        catFPrice: 0,
        catGPrice: 0,
        catHPrice: 0,
        catIPrice: 0,
        catJPrice: 0,
      },
    ]);

  const [inputValues, setInputValues] = useState({
    ParentGrp: "",
    ItemName: "",
    ItemId: "",
    SPH_Min: "",
    SPH_Max: "",
    SPH_Step: "",
    CYL_Min: "",
    CYL_Max: "",
    CYL_Step: "",
    Axis: "",
    Add_Min: "",
    Add_Max: "",
    Add_Step: "",
    Eye: "",
  });

  const handleChange = (index, field, value) => {
    // Allow empty string or valid decimal number
    if (value === "" || /^-?\d*\.?\d*$/.test(value)) {
      setProductPriceCategoryWiseData((prevData) => {
        const newData = [...prevData];
        newData[index] = {
          ...newData[index],
          [field]: value,
          isSelected: true,
        };
        return newData;
      });
    }
  };

  const handleRangeInputChange = (event) => {
    const { name, value } = event.target;
    console.log(`Changing ${name} to ${value}`);

    setInputValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  useEffect(() => {
    console.log("productPriceCategoryWiseData", productPriceCategoryWiseData);
  }, [productPriceCategoryWiseData]);

  const [isAllSelected, setIsAllSelected] = useState(false);

  function handleRightClick(e, rIndex, cIndex) {
    e.preventDefault();
    console.log(copyBtnRC);
    console.log({ rIndex, cIndex });

    if (copyBtnRC.R == rIndex && copyBtnRC.C == cIndex) {
      setCopyBtnRC({ R: -1, C: -1 });
    } else {
      setCopyBtnRC({ R: rIndex, C: cIndex });
    }
  }

  const handleChangeData = (index, key, value) => {
    let tempProductPriceCategoryWiseData = [...productPriceCategoryWiseData];

    tempProductPriceCategoryWiseData[index][key] = value;

    setProductPriceCategoryWiseData(tempProductPriceCategoryWiseData);
  };

  function handleCopyBtnClick(rIndex, key, value) {
    ;

    let tempProductPriceCategoryWiseData = [...productPriceCategoryWiseData];

    for (
      let i = value ? 0 : rIndex + 1;
      i < tempProductPriceCategoryWiseData.length;
      i++
    ) {
      tempProductPriceCategoryWiseData[i][key] =
        value || tempProductPriceCategoryWiseData[rIndex][key];
    }

    setProductPriceCategoryWiseData(tempProductPriceCategoryWiseData);
    setCopyBtnRC({ R: -1, C: -1 });

    if (value) {
      handleSelectAll({
        target: { checked: true },
      });
    }
  }

  useEffect(() => {
    let findFalse = productPriceCategoryWiseData.find(
      (item) => item.isSelected == false
    );

    if (findFalse === undefined) {
      setIsAllSelected(true);
    } else {
      setIsAllSelected(false);
    }
  }, [productPriceCategoryWiseData]);

  //************End Check box************/ /

  const handleSaveButton = async () => {
    ;
    setLoading(true);
    try {
      const selectedData = productPriceCategoryWiseData.filter(
        (lens) => lens.isSelected
      );
      const SendData = selectedData.map((lens) => ({
        itemd2_Id: Number(lens.itemd2_Id),
        salePrice: Number(lens.salePrice),
        purchasePrice: Number(lens.purchasePrice),
        mrpPrice: Number(lens.mrpPrice),
        costPrice: Number(lens.costPrice),
        rateA: Number(lens.catAPrice),
        rateB: Number(lens.catBPrice),
        rateC: Number(lens.catCPrice),
        rateD: Number(lens.catDPrice),
        rateE: Number(lens.catEPrice),
        rateF: Number(lens.catFPrice),
        rateG: Number(lens.catGPrice),
        rateH: Number(lens.catHPrice),
        rateI: Number(lens.catIPrice),
        rateJ: Number(lens.catJPrice),
      }));
      console.log("SendData", SendData);

      if (SendData.length === 0) {
        Swal.fire({
          icon: "warning",
          title: "Missing Selection",
          text: "Please select items to Update ",
          timer: 2000,
          showConfirmButton: false,
          timerProgressBar: true,
          width: "250px",
          customClass: {
            title: "swal2-custom-title",    confirmButton: 'my-confirm-button',
    cancelButton: 'my-cancel-button' ,

            popup: "swal2-custom-popup",
            htmlContainer: "swal2-custom-text",
            icon: "swal2-custom-icon",
          },
        });
        return;
      }

      const Issuccess =
        await PartyWiseItemPriceService.UpdateCategoryWiseItemPrice(SendData);
      console.log("Issuccess", Issuccess);
      if (Issuccess.data.statusCode == 200) {
        setProductPriceCategoryWiseData([
          {
            isSelected: false,
            itemd2_Id: 0,
            itemName: "",
            parentGroup: "-----",
            salePrice: 0,
            purchasePrice: 0,
            costPrice: 0,
            mrpPrice: 0,
            catAPrice: 0,
            catBPrice: 0,
            catCPrice: 0,
            catDPrice: 0,
            catEPrice: 0,
            catFPrice: 0,
            catGPrice: 0,
            catHPrice: 0,
            catIPrice: 0,
            catJPrice: 0,
          },
        ]);
        alert("Updated Successfuly");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const renderPriceInputCell = (index, name, colIndex) => (
    <td
      onContextMenu={(e) => handleRightClick(e, index, colIndex)}
      className="td_col6"
      style={{
        textAlign: "start",
        position: "relative",
      }}
    >
      <input
        className="table-input-box2"
        type="text"
        min="0"
        style={{ height: "30px" }}
        name={name}
        value={productPriceCategoryWiseData[index][name]}
        onChange={(e) => handleChange(index, e.target.name, e.target.value)}
      />
      {copyBtnRC.R === index && copyBtnRC.C === colIndex && (
        <button
          onClick={() => handleCopyBtnClick(index, name)}
          title="Copy to all rows"
          className="product-price-account-wise-copy-button"
        >
          <i className="fa-solid fa-copy"></i>
        </button>
      )}
    </td>
  );

  const handleCalc = () => {
    if (!selectedRateField) {
      Swal.fire({
        icon: "warning",
        title: "Missing Selection",
        text: "Please select a Rate Field (e.g., Rate A - Rate J).",
        timer: 2000,
        showConfirmButton: false,
        width: "250px",
        customClass: {
          title: "swal2-custom-title",    confirmButton: 'my-confirm-button',
    cancelButton: 'my-cancel-button' ,

          popup: "swal2-custom-popup",
          htmlContainer: "swal2-custom-text",
          icon: "swal2-custom-icon",
        },
      });
      return;
    }

    if (!selectedBaseField) {
      Swal.fire({
        icon: "warning",
        title: "Missing Selection",
        text: "Please select a Base Field (e.g., Sale Price, Purchase Price).",
        timer: 2000,
        showConfirmButton: false,
        width: "250px",
        customClass: {
          title: "swal2-custom-title",    confirmButton: 'my-confirm-button',
    cancelButton: 'my-cancel-button' ,

          popup: "swal2-custom-popup",
          htmlContainer: "swal2-custom-text",
          icon: "swal2-custom-icon",
        },
      });
      return;
    }

    if (!selectedOperator) {
      Swal.fire({
        icon: "warning",
        title: "Missing Operator",
        text: "Please select a mathematical operator.",
        timer: 2000,
        showConfirmButton: false,
        imer: 2500,

        width: "250px",
        customClass: {
          title: "swal2-custom-title",    confirmButton: 'my-confirm-button',
    cancelButton: 'my-cancel-button' ,

          popup: "swal2-custom-popup",
          htmlContainer: "swal2-custom-text",
          icon: "swal2-custom-icon",
        },
      });
      return;
    }

    if (calculationValue === "" || isNaN(Number(calculationValue))) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Value",
        text: "Please enter a valid numeric value.",
        timer: 2000,
        showConfirmButton: false,
        width: "250px",
        customClass: {
          title: "swal2-custom-title",    confirmButton: 'my-confirm-button',
    cancelButton: 'my-cancel-button' ,

          popup: "swal2-custom-popup",
          htmlContainer: "swal2-custom-text",
          icon: "swal2-custom-icon",
        },
      });
      return;
    }

    handleRateCalculationChange(
      selectedRateField,
      selectedBaseField,
      selectedOperator,
      Number(calculationValue)
    );
  };

  /*********Calculation********/
  const handleRateCalculationChange = (
    selectedRate,
    baseField,
    operator,
    value
  ) => {
    ;
    const rateFieldMap = {
      "Rate A": "catAPrice",
      "Rate B": "catBPrice",
      "Rate C": "catCPrice",
      "Rate D": "catDPrice",
      "Rate E": "catEPrice",
      "Rate F": "catFPrice",
      "Rate G": "catGPrice",
      "Rate H": "catHPrice",
      "Rate I": "catIPrice",
      "Rate J": "catJPrice",
    };

    const targetField = rateFieldMap[selectedRate];
    if (
      !targetField ||
      !["salePrice", "purchasePrice", "costPrice", "mrpPrice"].includes(
        baseField
      )
    ) {
      console.error("Invalid selection");
      return;
    }

    const updatedData = productPriceCategoryWiseData.map((item) => {
      let base = parseFloat(item[baseField]) || 0;
      let num = parseFloat(value) || 0;
      let result;

      switch (operator) {
        case "+":
          result = base + num;
          break;
        case "-":
          result = base - num;
          break;
        case "*":
          result = base * num;
          break;
        case "/":
          result = num !== 0 ? base / num : base;
          break;
        default:
          result = base;
      }

      return {
        ...item,
        [targetField]: parseFloat(result.toFixed(2)),
      };
    });

    setProductPriceCategoryWiseData(updatedData);
  };
  /*********Calculation********/
  const handleAxisChange = (event) => {
    ShowButtonClick(event.target.value);
  };

  const ChangePriceInAll = (e, index) => {
    const value = e.target.value;
    const name = e.target.name;
    handleCopyBtnClick(index, name, value);
  };

  const [selectedAxis, setSelectedAxis] = useState("");
  return (
    <div className="">
      <PageTabs />
      <div className="nav-1" style={{ height: "89vh" }}>
        <div className="panel-heading">
          <h2 className="panel-title">Product Price Account Category Wise</h2>
          <MainButton SaveButton={handleSaveButton} />
        </div>
        <div className="panel panel-default">
          <div className="panel-body">
            <div className="search_panel_hd1">
              <div style={{ width: "60%" }}>
                <div
                  className="col-sm-n1"
                  style={{
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <AutoSuggestionBox
                    SuggestionList={filteredItems}
                    ShowSuggestionBox={isDropdownOpen}
                    handleSelection={handleDataSelection}
                    DivClassName="input-box-m1"
                    InputClassName="modify_im_input mode_category"
                    handleKeyPress={handleKeyPress}
                    Ref={null}
                    NextRef={null}
                    InputId={""}
                    Name="itemd2_Id"
                    inputOnChangeFunction={(e) => handleInputChange(e, 3)}
                    InputLabel="Product Group"
                    AddNewButtonAllow={false}
                  />

                  <AutoSuggestionBox
                    SuggestionList={filteredItems}
                    ShowSuggestionBox={isDropdownOpen1}
                    handleSelection={handleDataSelection}
                    DivClassName="input-box-m1"
                    InputClassName="modify_im_input mode_category"
                    handleKeyPress={handleKeyPress}
                    Ref={null}
                    NextRef={null}
                    InputId={""}
                    Name="itemd2_Id"
                    inputOnChangeFunction={(e) => handleInputChange(e, 4)}
                    InputLabel="Product Name"
                    AddNewButtonAllow={false}
                  />

                  <div
                    onClick={showShowFilterPopUp}
                    className="product-price-account-wise-filter-button"
                  >
                    <i class="fa-solid fa-filter"></i>
                  </div>
                </div>
              </div>

              <div
                className="search_panel_right product-price-account-wise-search_panel_right"
                style={{}}
              ></div>
            </div>
            {showFilterPopUp && (
              <div style={{ marginBottom: "1px" }}>
                <RangeInput
                  inputValues={inputValues}
                  handleInputChange={handleRangeInputChange}
                  hideAxis={true}
                />
                <div
                  style={{
                    marginTop: "10px",
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div class="tooltip6" style={{ width: "120px" }}>
                    <label
                      className=" "
                      style={{ textAlign: "center", marginRight: "5px" }}
                    >
                      Axis
                    </label>
                    <select
                      className="modify_im_input mode_category table-input"
                      style={{ width: "90px" }}
                      value={selectedAxis}
                      onChange={(e) => setSelectedAxis(Number(e.target.value))}
                      name="Eye"
                      type="text"
                      required
                    >
                      {axisData &&
                        axisData.map((item, index) => (
                          <option key={index} value={isNaN(item) ? "" : item}>
                            {isNaN(item) ? "" : item}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div
                    className="shortcutkeys-header"
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      margin: "5px 10px",
                    }}
                  >
                    <button
                      // className="ml-10 btn-red table-input box-size1 mt-2"
                      className="btn-blue ml-10"
                      onClick={() => ShowButtonClick(null)}
                      type="number"
                      required
                      style={{
                        backgroundColor: "darkgreen",
                        padding: "0px",
                        height: "35px",
                        width: "10%",
                        border: "none",
                      }}
                    >
                      Show Existing
                    </button>

                    {/* <PaginationControl
                      currentPage={currentPage}
                      totalRecords={totalRecords}
                      pageSize={pageSize}
                      onPrevious={handleprev}
                      onNext={handlenext}
                    /> */}
                  </div>
                </div>
              </div>
            )}
            <div className="col-sm-12">
              <div className="table-resposive">
                {productPriceCategoryWiseData &&
                  productPriceCategoryWiseData.length > 0 && (
                    <table
                      id="tblTransactionList"
                      className="table_hd1 table-bordered1 fixedheightTable"
                      frame="box"
                      style={{ maxHeight: "55vh" }}
                    >
                      <thead>
                        <tr style={{ height: "25px", background: "#f1f1f1" }}>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>
                            <input
                              type="text"
                              style={{ width: "60px", height: "20px" }}
                              className="table-input box-size1 toolTextWdth"
                              onBlur={(e) => ChangePriceInAll(e, 0)}
                              name="salePrice"
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              style={{ width: "60px", height: "20px" }}
                              className="table-input box-size1 toolTextWdth"
                              onBlur={(e) => ChangePriceInAll(e, 1)}
                              name="purchasePrice"
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              style={{ width: "60px", height: "20px" }}
                              className="table-input box-size1 toolTextWdth"
                              onBlur={(e) => ChangePriceInAll(e, 2)}
                              name="costPrice"
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              style={{ width: "60px", height: "20px" }}
                              className="table-input box-size1 toolTextWdth"
                              onBlur={(e) => ChangePriceInAll(e, 3)}
                              name="mrpPrice"
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              style={{ width: "60px", height: "20px" }}
                              className="table-input box-size1 toolTextWdth"
                              onBlur={(e) => ChangePriceInAll(e, 4)}
                              name="catAPrice"
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              style={{ width: "60px", height: "20px" }}
                              className="table-input box-size1 toolTextWdth"
                              onBlur={(e) => ChangePriceInAll(e, 5)}
                              name="catBPrice"
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              style={{ width: "60px", height: "20px" }}
                              className="table-input box-size1 toolTextWdth"
                              onBlur={(e) => ChangePriceInAll(e, 6)}
                              name="catCPrice"
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              style={{ width: "60px", height: "20px" }}
                              className="table-input box-size1 toolTextWdth"
                              onBlur={(e) => ChangePriceInAll(e, 7)}
                              name="catDPrice"
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              style={{ width: "60px", height: "20px" }}
                              className="table-input box-size1 toolTextWdth"
                              onBlur={(e) => ChangePriceInAll(e, 8)}
                              name="catEPrice"
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              style={{ width: "60px", height: "20px" }}
                              className="table-input box-size1 toolTextWdth"
                              onBlur={(e) => ChangePriceInAll(e, 9)}
                              name="catFPrice"
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              style={{ width: "60px", height: "20px" }}
                              className="table-input box-size1 toolTextWdth"
                              onBlur={(e) => ChangePriceInAll(e, 10)}
                              name="catGPrice"
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              style={{ width: "60px", height: "20px" }}
                              className="table-input box-size1 toolTextWdth"
                              onBlur={(e) => ChangePriceInAll(e, 11)}
                              name="catHPrice"
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              style={{ width: "60px", height: "20px" }}
                              className="table-input box-size1 toolTextWdth"
                              onBlur={(e) => ChangePriceInAll(e, 12)}
                              name="catIPrice"
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              style={{ width: "60px", height: "20px" }}
                              className="table-input box-size1 toolTextWdth"
                              onBlur={(e) => ChangePriceInAll(e, 13)}
                              name="catJPrice"
                            />
                          </td>
                        </tr>
                      </thead>
                      <thead
                        textAlign="center"
                        className="thead_scroll_col1"
                        style={{
                          background: "#212e4f",
                          color: "white",
                          height: "35px",
                        }}
                      >
                        <tr>
                          <th className="td_col6" style={{ width: "50px" }}>
                            <div>
                              <input
                                type="checkbox"
                                className="check_box"
                                checked={isAllSelected}
                                onChange={handleSelectAll}
                              />
                            </div>
                          </th>

                          <th className="td_col6" style={{ width: "50px" }}>
                            <div className="table_head_mmb1">S.No.</div>
                          </th>

                          <th className="td_col6">
                            <div className="table_head_nnb">
                              <div
                                className="table_head_mmb1"
                                style={{ textAlign: "center" }}
                              >
                                Item Name
                              </div>
                            </div>
                          </th>

                          <th className="td_col6">
                            <div className="table_head_mab">
                              <div
                                className="table_head_nnb1"
                                style={{ textAlign: "center" }}
                              >
                                Parent Group
                              </div>
                            </div>
                          </th>

                          
                          <th className="td_col6">
                            <div className="table_head_nhb">
                              <div
                                className="table_head_mmb1"
                                style={{ textAlign: "center" }}
                              >
                                Pur Price
                              </div>
                            </div>
                          </th>
                          <th className="td_col6">
                            <div className="table_head_nhb">
                              <div
                                className="table_head_mmb1"
                                style={{ textAlign: "center" }}
                              >
                                Cost Price
                              </div>
                            </div>
                          </th>
                          <th className="td_col6">
                            <div className="table_head_nhb">
                              <div
                                className="table_head_mmb1"
                                style={{ textAlign: "center" }}
                              >
                                Mrp Price
                              </div>
                            </div>
                          </th>
                          <th className="td_col6">
                            <div className="table_head_nhb">
                              <div
                                className="table_head_mmb1"
                                style={{ textAlign: "center" }}
                              >
                                Sale Price
                              </div>
                            </div>
                          </th>

                          {[
                            "A",
                            "B",
                            "C",
                            "D",
                            "E",
                            "F",
                            "G",
                            "H",
                            "I",
                            "J",
                          ].map((rate) => (
                            <th className="td_col6" key={rate}>
                              <div className="table_head_nhb">
                                <div
                                  className="table_head_mmb1"
                                  style={{ textAlign: "center" }}
                                >
                                  {`Rate ${rate}`}
                                </div>
                              </div>
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody className="tbody_body_m1">
                        {/* {productPriceCategoryWiseData.map((item, index) => (
                          <tr key={index} className="table_tbody_tr1">
                            <td
                              className="td_col6"
                              style={{ textAlign: "center" }}
                            >
                              <input
                                type="checkbox"
                                className="check_box"
                                checked={item.isSelected}
                                onChange={(e) =>
                                  handleChangeData(
                                    index,
                                    "isSelected",
                                    e.target.checked
                                  )
                                }
                                name=""
                                id=""
                              />
                            </td>

                            <td className="td_col6">{index + 1}</td>

                            <td
                              className="td_col6"
                              style={{ textAlign: "center" }}
                            >
                              {item.itemName}
                            </td>
                            <td
                              className="td_col6"
                              style={{ textAlign: "center" }}
                            >
                              {item.parentGroup}
                            </td>
                            <td
                              onContextMenu={(e) =>
                                handleRightClick(e, index, 0)
                              }
                              className="td_col6"
                              style={{
                                textalign: "start",
                                position: "relative",
                                border: "none",
                              }}
                            >
                              <input
                                className="table-input-box2"
                                type="number"
                                min="0"
                                name="salePrice"
                                id=""
                                value={item["salePrice"]}
                                onChange={(e) =>
                                  handleChangeData(
                                    index,
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                              />
                              {copyBtnRC.R == index && copyBtnRC.C == 0 && (
                                <button
                                  onClick={() =>
                                    handleCopyBtnClick(index, "salePrice")
                                  }
                                  title="Copy to all rows"
                                  className="product-price-account-wise-copy-button"
                                >
                                  <i class="fa-solid fa-copy"></i>
                                </button>
                              )}
                            </td>
                            <td
                              onContextMenu={(e) =>
                                handleRightClick(e, index, 1)
                              }
                              className="td_col6"
                              style={{
                                textalign: "start",
                                position: "relative",
                              }}
                            >
                              <input
                                className="table-input-box2"
                                type="number"
                                min="0"
                                name="catAPrice"
                                id=""
                                value={item["catAPrice"]}
                                onChange={(e) =>
                                  handleChangeData(
                                    index,
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                              />
                              {copyBtnRC.R == index && copyBtnRC.C == 1 && (
                                <button
                                  onClick={() =>
                                    handleCopyBtnClick(index, "catAPrice")
                                  }
                                  title="Copy to all rows"
                                  className="product-price-account-wise-copy-button"
                                >
                                  <i class="fa-solid fa-copy"></i>
                                </button>
                              )}
                            </td>
                            <td
                              onContextMenu={(e) =>
                                handleRightClick(e, index, 2)
                              }
                              className="td_col6"
                              style={{
                                textalign: "start",
                                position: "relative",
                              }}
                            >
                              <input
                                className="table-input-box2"
                                type="number"
                                min="0"
                                name="catBPrice"
                                id=""
                                value={item["catBPrice"]}
                                onChange={(e) =>
                                  handleChangeData(
                                    index,
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                              />
                              {copyBtnRC.R == index && copyBtnRC.C == 2 && (
                                <button
                                  onClick={() =>
                                    handleCopyBtnClick(index, "catBPrice")
                                  }
                                  title="Copy to all rows"
                                  className="product-price-account-wise-copy-button"
                                >
                                  <i class="fa-solid fa-copy"></i>
                                </button>
                              )}
                            </td>
                            <td
                              onContextMenu={(e) =>
                                handleRightClick(e, index, 3)
                              }
                              className="td_col6"
                              style={{
                                textalign: "start",
                                position: "relative",
                              }}
                            >
                              <input
                                className="table-input-box2"
                                type="number"
                                min="0"
                                name="catCPrice"
                                id=""
                                value={item["catCPrice"]}
                                onChange={(e) =>
                                  handleChangeData(
                                    index,
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                              />
                              {copyBtnRC.R == index && copyBtnRC.C == 3 && (
                                <button
                                  onClick={() =>
                                    handleCopyBtnClick(index, "catCPrice")
                                  }
                                  title="Copy to all rows"
                                  className="product-price-account-wise-copy-button"
                                >
                                  <i class="fa-solid fa-copy"></i>
                                </button>
                              )}
                            </td>
                            <td
                              onContextMenu={(e) =>
                                handleRightClick(e, index, 4)
                              }
                              className="td_col6"
                              style={{
                                textalign: "start",
                                position: "relative",
                              }}
                            >
                              <input
                                className="table-input-box2"
                                type="number"
                                min="0"
                                name="catDPrice"
                                id=""
                                value={item["catDPrice"]}
                                onChange={(e) =>
                                  handleChangeData(
                                    index,
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                              />
                              {copyBtnRC.R == index && copyBtnRC.C == 4 && (
                                <button
                                  onClick={() =>
                                    handleCopyBtnClick(index, "catDPrice")
                                  }
                                  title="Copy to all rows"
                                  className="product-price-account-wise-copy-button"
                                >
                                  <i class="fa-solid fa-copy"></i>
                                </button>
                              )}
                            </td>
                            <td
                              onContextMenu={(e) =>
                                handleRightClick(e, index, 5)
                              }
                              className="td_col6"
                              style={{
                                textalign: "start",
                                position: "relative",
                              }}
                            >
                              <input
                                className="table-input-box2"
                                type="number"
                                min="0"
                                name="catEPrice"
                                id=""
                                value={item["catEPrice"]}
                                onChange={(e) =>
                                  handleChangeData(
                                    index,
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                              />
                              {copyBtnRC.R == index && copyBtnRC.C == 5 && (
                                <button
                                  onClick={() =>
                                    handleCopyBtnClick(index, "catEPrice")
                                  }
                                  title="Copy to all rows"
                                  className="product-price-account-wise-copy-button"
                                >
                                  <i class="fa-solid fa-copy"></i>
                                </button>
                              )}
                            </td>
                            <td
                              onContextMenu={(e) =>
                                handleRightClick(e, index, 6)
                              }
                              className="td_col6"
                              style={{
                                textalign: "start",
                                position: "relative",
                              }}
                            >
                              <input
                                className="table-input-box2"
                                type="number"
                                min="0"
                                name="catFPrice"
                                id=""
                                value={item["catFPrice"]}
                                onChange={(e) =>
                                  handleChangeData(
                                    index,
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                              />
                              {copyBtnRC.R == index && copyBtnRC.C == 6 && (
                                <button
                                  onClick={() =>
                                    handleCopyBtnClick(index, "catFPrice")
                                  }
                                  title="Copy to all rows"
                                  className="product-price-account-wise-copy-button"
                                >
                                  <i class="fa-solid fa-copy"></i>
                                </button>
                              )}
                            </td>
                            <td
                              onContextMenu={(e) =>
                                handleRightClick(e, index, 7)
                              }
                              className="td_col6"
                              style={{
                                textalign: "start",
                                position: "relative",
                              }}
                            >
                              <input
                                className="table-input-box2"
                                type="number"
                                min="0"
                                name="catGPrice"
                                id=""
                                value={item["catGPrice"]}
                                onChange={(e) =>
                                  handleChangeData(
                                    index,
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                              />
                              {copyBtnRC.R == index && copyBtnRC.C == 7 && (
                                <button
                                  onClick={() =>
                                    handleCopyBtnClick(index, "catGPrice")
                                  }
                                  title="Copy to all rows"
                                  className="product-price-account-wise-copy-button"
                                >
                                  <i class="fa-solid fa-copy"></i>
                                </button>
                              )}
                            </td>
                            <td
                              onContextMenu={(e) =>
                                handleRightClick(e, index, 8)
                              }
                              className="td_col6"
                              style={{
                                textalign: "start",
                                position: "relative",
                              }}
                            >
                              <input
                                className="table-input-box2"
                                type="number"
                                min="0"
                                name="catHPrice"
                                id=""
                                value={item["catHPrice"]}
                                onChange={(e) =>
                                  handleChangeData(
                                    index,
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                              />
                              {copyBtnRC.R == index && copyBtnRC.C == 8 && (
                                <button
                                  onClick={() =>
                                    handleCopyBtnClick(index, "catHPrice")
                                  }
                                  title="Copy to all rows"
                                  className="product-price-account-wise-copy-button"
                                >
                                  <i class="fa-solid fa-copy"></i>
                                </button>
                              )}
                            </td>
                            <td
                              onContextMenu={(e) =>
                                handleRightClick(e, index, 9)
                              }
                              className="td_col6"
                              style={{
                                textalign: "start",
                                position: "relative",
                              }}
                            >
                              <input
                                className="table-input-box2"
                                type="number"
                                min="0"
                                name="catIPrice"
                                id=""
                                value={item["catIPrice"]}
                                onChange={(e) =>
                                  handleChangeData(
                                    index,
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                              />
                              {copyBtnRC.R == index && copyBtnRC.C == 9 && (
                                <button
                                  onClick={() =>
                                    handleCopyBtnClick(index, "catIPrice")
                                  }
                                  title="Copy to all rows"
                                  className="product-price-account-wise-copy-button"
                                >
                                  <i class="fa-solid fa-copy"></i>
                                </button>
                              )}
                            </td>
                            <td
                              onContextMenu={(e) =>
                                handleRightClick(e, index, 10)
                              }
                              className="td_col6"
                              style={{
                                textalign: "start",
                                position: "relative",
                              }}
                            >
                              <input
                                className="table-input-box2"
                                type="number"
                                min="0"
                                name="catJPrice"
                                id=""
                                value={item["catJPrice"]}
                                onChange={(e) =>
                                  handleChangeData(
                                    index,
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                              />
                              {copyBtnRC.R == index && copyBtnRC.C == 10 && (
                                <button
                                  onClick={() =>
                                    handleCopyBtnClick(index, "catJPrice")
                                  }
                                  title="Copy to all rows"
                                  className="product-price-account-wise-copy-button"
                                >
                                  <i class="fa-solid fa-copy"></i>
                                </button>
                              )}
                            </td>
                          </tr>
                        ))} */}

                        {productPriceCategoryWiseData.map((item, index) => (
                          <tr key={index} className="table_tbody_tr1">
                            <td
                              className="td_col6"
                              style={{ textAlign: "center" }}
                            >
                              <input
                                type="checkbox"
                                className="check_box"
                                checked={item.isSelected}
                                onChange={(e) =>
                                  handleChangeData(
                                    index,
                                    "isSelected",
                                    e.target.checked
                                  )
                                }
                              />
                            </td>
                            <td className="td_col6">
                              {(currentPage - 1) * pageSize + index + 1}
                            </td>
                            <td
                              className="td_col6"
                              style={{ textAlign: "center" }}
                            >
                              {item.itemName}
                            </td>
                            <td
                              className="td_col6"
                              style={{ textAlign: "center" }}
                            >
                              {item.parentGroup}
                            </td>

                            {[
                              "purchasePrice",
                              "costPrice",
                              "mrpPrice",
                              "salePrice",
                              "catAPrice",
                              "catBPrice",
                              "catCPrice",
                              "catDPrice",
                              "catEPrice",
                              "catFPrice",
                              "catGPrice",
                              "catHPrice",
                              "catIPrice",
                              "catJPrice",
                            ].map((key, colIndex) =>
                              renderPriceInputCell(index, key, colIndex)
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="input-remark-01">
        <div className="input-remark-left01">
          <div className="input-remark-box-mm1">
            <select
              style={{ height: "35px" }}
              className="modify_im_input mode_limits mode_category input-so1"
              value={selectedRateField}
              onChange={(e) => setSelectedRateField(e.target.value)}
              required
            >
              {Array.from({ length: 10 }, (_, i) => (
                <option key={i} value={`Rate ${String.fromCharCode(65 + i)}`}>
                  Rate {String.fromCharCode(65 + i)}
                </option>
              ))}
            </select>
          </div>

          <div className="input-remark-box-mm1 ">
            <center className="equal">=</center>
          </div>
          <div className="input-box-vo1">
            <select
              style={{ height: "35px" }}
              className="modify_im_input mode_category input-so1 mid-size-m01"
              required
              value={selectedBaseField}
              onChange={(e) => setSelectedBaseField(e.target.value)}
            >
              <option value="">Select Base Field</option>
              <option value="salePrice">Sale Price</option>
              <option value="purchasePrice">Purchase Price</option>
              <option value="costPrice">Cost Price</option>
              <option value="mrpPrice">MRP Price</option>
            </select>
          </div>

          <div className="input-box-vo1">
            {/* Operator Dropdown */}
            <div className="input-remark-box-mm1 load_pad">
              <select
                style={{ height: "35px" }}
                className="modify_im_input mode_limits mode_category input-so1"
                required
                value={selectedOperator}
                onChange={(e) => setSelectedOperator(e.target.value)}
              >
                <option value="-">SUB</option>
                <option value="+">ADD</option>
                <option value="*">MULTIPLY</option>
                <option value="/">DIVIDE</option>
              </select>
            </div>
          </div>

          <div className="input-box-vo1">
            <input
              style={{ height: "35px" }}
              className="modify_im_input mode_category input-so1 mid-size-m01"
              type="number"
              required
              value={calculationValue}
              onChange={(e) => setCalculationValue(e.target.value)}
              placeholder="Enter value"
            />
          </div>
          <div className="button-mp3">
            <button
              id="step-5"
              className="save-button-main-save hovered"
              onClick={handleCalc}
              style={{ height: "35px" }}
            >
              Calculate
              <i className="fa-solid fa fa-calculator im-icon-2"></i>
            </button>
          </div>
          {/* </div> */}
        </div>
        <div className="input-remark-right">
          <PaginationControl
            currentPage={currentPage}
            totalRecords={totalRecords}
            pageSize={pageSize}
            onPrevious={handleprev}
            onNext={handlenext}
          />
        </div>
        {/* <div className="button-mp2">
          <button className="save_cat_btn">Save Category Price</button>
        </div> */}
      </div>
      {/* <div className="wrapper">
        <div className="container">
          <div className=" content-row-1">
            <div className="class_control">
              <div className="balance-1">
                <div className="p-11">
                  <p className="balance-p1">
                    <i className="fa-solid fa-arrow-up icon_3"></i>Sale
                  </p>
                </div>
                <div className="p-12">
                  <p className="balance-p2">
                    <i className="fa-solid fa-indian-rupee-sign rs_sign"></i>100
                  </p>
                </div>
              </div>
              <div className="balance-1">
                <div className="p-11">
                  <p className="balance-p1">
                    {" "}
                    <i className="fa-solid fa-clipboard icon_3"></i> Total
                  </p>
                </div>
                <div className="p-12">
                  <p className="balance-p2">
                    <i className="fa-solid fa-indian-rupee-sign rs_sign"></i>200
                  </p>
                </div>
              </div>
              <div className="balance-1">
                <div className="p-11">
                  <p className="balance-p1">
                    <i className="fa-solid fa-arrow-down icon_3"></i>Return
                  </p>
                </div>
                <div className="p-12">
                  <p className="balance-p2">
                    <i className="fa-solid fa-indian-rupee-sign rs_sign"></i>100
                  </p>
                </div>
              </div>
            </div>
            <div className="class_control_2">
              <div className="parti_1">
                <div className="sub_parti_1">
                  <p className="parti-p-1">Parties</p>
                </div>
              </div>
              <div className="parti_1">
                <div className="sub_parti_1">
                  <p className="parti-p-1">Trasaction</p>
                </div>
              </div>
              <div className="parti_1">
                <div className="sub_parti_1">
                  <p className="parti-p-1">Items</p>
                </div>
              </div>
            </div>
            <div className="class_control_4">
              <div className="col_ms_1">
                <p className="p_13">Recent History</p>
                <div className="con_input_1">
                  <input
                    type="text"
                    className="input_box_2"
                    placeholder="Search..."
                  />
                </div>
              </div>

              <div className="col_sm_11">
                <div className="col_sm_21">
                  <div className="col_sm_12">
                    <div className="con_name_1">
                      <p className="con_p_3">Akash kumar</p>
                    </div>
                    <div className="con_name_1">
                      <p className="con_p_1">Sale</p>
                    </div>
                    <div className="con_name_1">
                      <p className="con_p_2">Total</p>
                    </div>
                    <div className="con_name_1">
                      <p className="con_p_4">
                        <i className="fa-solid fa-indian-rupee-sign rs_sign1"></i>
                        1000
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col_sm_13">
                  <div className="col_sm_12">
                    <div className="con_total_3">
                      <p className="con_p_3">Balance</p>
                    </div>
                    <div className="con_total_3">
                      <p className="con_price_p">
                        <i className="fa-solid fa-indian-rupee-sign rs_sign1"></i>
                        1000
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col_sm_14">
                  <div className="col_sm_12">
                    <div className="con_sale_2">
                      <p className="con_p_3">Date</p>
                    </div>
                    <div className="con_sale_2">
                      <p>#1</p>
                    </div>
                    <div className="con_name_1 con_name_7">
                      <i className="fa-solid fa-print"></i>
                      <i className="fa-solid fa-share"></i>
                      <i className="fa-solid fa-ellipsis-vertical"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <ListSaveButton />
            </div>
          </div>
        </div>
      </div> */}
      {loading && <Loader />}
    </div>
  );
}

export default ProductPriceAccCatWise;
